import React from 'react';
import PropTypes from 'prop-types';

import Modal from '@wui/basics/modal';
import Button from '@wui/input/button';
import Spacer from '@wui/layout/spacer';
import Typography from '@wui/basics/typography';

import { useGlobalContext } from 'hooks';

const ExitModal = ({ open, onClose }) => {
  const { serverData } = useGlobalContext();

  return (
    <Modal title="Please Note" open={open} onClose={onClose}>
      <Typography>
        Your plan includes access to online deed preparation through Bundle. You may choose to use
        Bundle for deed notarization and recording at an additional cost. Bundle is responsible for
        its deed services.
      </Typography>
      <br />
      <Typography>
        By clicking on the "Continue" button below, you will leave the MetLife Legal Plans website.
      </Typography>
      <Spacer v={16} />
      <Button
        variant="contained"
        color="primary"
        noMinWidth
        onClick={() => (window.location = serverData.bundleUrl)}
      >
        Continue
      </Button>
      <Spacer h={16} inline />
      <Button variant="outlined" noMinWidth onClick={onClose}>
        Cancel
      </Button>
    </Modal>
  );
};

ExitModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default ExitModal;
